import type { PaintedWallGeometry } from './painted-wall-geometry';
export interface PaintedWallWire { casterId: string; abilityId: string; targetSelection: string; geometry: PaintedWallGeometry }
declare global { interface Window { ftTakePaintedWall?: (caster: string, ability: string, selection: string) => PaintedWallWire | null } }
export function armPaintedWall(wire: PaintedWallWire): void {
  const expires = Date.now() + 30000;
  window.ftTakePaintedWall = (caster, ability, selection) => {
    delete window.ftTakePaintedWall;
    return Date.now() <= expires && caster.toUpperCase() === wire.casterId.toUpperCase()
      && ability.toUpperCase() === wire.abilityId.toUpperCase() && selection === wire.targetSelection ? wire : null;
  };
}
